import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("currentUser"));
    if (storedUser) setUser(storedUser);
  }, []);

  const login = (email, password) => {
    const users = JSON.parse(localStorage.getItem("users")) || [];
    const foundUser = users.find(u => u.email === email && u.password === password);
    if (foundUser) {
      setUser(foundUser);
      localStorage.setItem("currentUser", JSON.stringify(foundUser));
      return true;
    }
    return false;
  };

  const signup = (formData) => {
  const users = JSON.parse(localStorage.getItem("users")) || [];

  const existingUser = users.find(user => user.email === formData.email);
  if (existingUser) {
    alert("User with this email already exists.");
    return;
  }

  const newUser = {
    firstName: formData.firstName,
    lastName: formData.lastName,
    email: formData.email,
    mobile: formData.mobile,
    password: formData.password,
    gender:formData.gender,
  };

  users.push(newUser);
  localStorage.setItem("users", JSON.stringify(users));
  localStorage.setItem("currentUser", JSON.stringify(newUser));
  setUser(newUser);
};


  const logout = () => {
    setUser(null);
    localStorage.removeItem("currentUser");
   
  };

  const changePassword = ({ oldPassword, newPassword }) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const users = JSON.parse(localStorage.getItem("users")) || [];


  if (currentUser.password !== oldPassword) {
    return { success: false, message: "Old password is incorrect." };
  }

  
  const updatedUsers = users.map((user) =>
    user.email === currentUser.email
      ? { ...user, password: newPassword }
      : user
  );

  const updatedUser = { ...currentUser, password: newPassword };
  localStorage.setItem("users", JSON.stringify(updatedUsers));
  localStorage.setItem("currentUser", JSON.stringify(updatedUser));
  setUser(updatedUser);

  return { success: true };
};


  return (
    <AuthContext.Provider value={{ user, login, signup, logout,changePassword }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
